import React from 'react';
import { X } from 'lucide-react';
import { FeedbackPanel } from './FeedbackPanel';

interface SessionFeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  sessionId: string | null;
}

export const SessionFeedbackModal: React.FC<SessionFeedbackModalProps> = ({
  isOpen,
  onClose,
  sessionId,
}) => {
  if (!isOpen || !sessionId) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Modal */}
      <div
        className="fixed inset-0 z-50 flex items-center justify-center p-4 safe-top safe-bottom"
        role="dialog"
        aria-modal="true"
        aria-labelledby="session-feedback-title"
      >
        <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-rm-neutral-600/20 flex-shrink-0">
            <h2 id="session-feedback-title" className="text-lg font-semibold text-rm-ink-900">
              Session Feedback
            </h2>
            <button
              onClick={onClose}
              className="touch-target rounded-full p-2 hover:bg-rm-bg-50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-rm-accent-500"
              aria-label="Close modal"
            >
              <X className="w-5 h-5 text-rm-ink-900" />
            </button>
          </div>

          {/* Content - Scrollable */}
          <div className="flex-1 overflow-y-auto">
            <FeedbackPanel sessionId={sessionId} isVisible={true} />
          </div>
        </div>
      </div>
    </>
  );
};
